import request from '@/utils/request'

// 项目门禁列表
export function projectGuards(projectCode) {
  return request({
    url: `/api/guard/auth/guard-list/${projectCode}`,
    method: "get"
  });
}

// 房屋门禁列表
export function houseGuardList(data) {
  return request({
    url: `/api/guard/auth/house-list`,
    method: "post",
    data
  });
}

// 门禁编辑保存
export function saveHouseGuard(data) {
  return request({
    url: `/api/guard/auth/house-save`,
    method: "post",
    data
  });
}

// 房屋门禁详情
export function guardDetail(houseCode) {
  return request({
    url: `/api/guard/auth/house/${houseCode}`,
    method: "get",
  });
}

// 员工门禁列表
export function staffGuardList(data) {
  return request({
    url: `/api/guard/auth/user-list`,
    method: "post",
    data
  });
}

// 员工门禁保存
export function saveStaffGuard(data) {
  return request({
    url: `/api/guard/auth/user-save`,
    method: "post",
    data
  });
}

// 员工门禁详情
export function staffGuardDetail(userId) {
  return request({
    url: `/api/guard/auth/user/${userId}`,
    method: "get",
  });
}
